import React from 'react';
import {useListContext} from 'react-admin';
import {useFormContext} from 'react-hook-form';

import {Button} from '../../../../components';
import {ERoleStatus} from '../../../../models';

import {defaultFiltersValues} from './RoleFilterForm';

export const ClearFiltersButton = () => {
    const {displayedFilters, setFilters} = useListContext();
    const {setValue} = useFormContext();

    const onClearFilters = () => {
        setValue('lastMatchingAfter', null);
        setValue('lastMatchingBefore', null);
        setValue('q', '');
        setValue('statuses', [ERoleStatus.Submitted]);
        setValue('submittedAfter', null);
        setValue('submittedBefore', null);
        setValue('tier', 'ALL');

        setFilters(defaultFiltersValues, displayedFilters);
    };

    return (
        <Button
            className="secondary"
            color="primary"
            disableElevation
            variant="contained"
            onClick={onClearFilters}
        >
            Clear filters
        </Button>
    );
};